import React, { useState } from 'react';

const faqs = [
  {
    question: 'Wat is een freelance contract voor ZZP\'ers?',
    answer: 'Een freelance contract voor ZZP\'ers (zelfstandigen zonder personeel) is een juridisch bindende overeenkomst tussen een ZZP\'er en een opdrachtgever. Het legt alle afspraken vast over de opdracht, vergoeding, deadlines en intellectueel eigendom, conform het Nederlands Burgerlijk Wetboek. Een goed ZZP-contract beschermt je bij onbetaalde facturen en juridische conflicten.',
  },
  {
    question: 'Heb ik een KvK-nummer nodig als ZZP\'er in Nederland?',
    answer: 'Ja, als ZZP\'er in Nederland ben je verplicht om je in te schrijven bij de Kamer van Koophandel (KvK) en een KvK-nummer te verkrijgen. Dit 8-cijferig nummer moet vermeld worden op al je facturen en contracten. Zonder KvK-inschrijving mag je officieel geen zelfstandige ondernemersactiviteiten uitoefenen in Nederland.',
  },
  {
    question: 'Welk recht geldt voor ZZP contracten in Nederland?',
    answer: 'ZZP contracten in Nederland worden beheerst door het Burgerlijk Wetboek (BW), met name Boek 7 (Bijzondere overeenkomsten). De Wet Deregulering Beoordeling Arbeidsrelaties (Wet DBA) is ook relevant voor de beoordeling van de arbeidsrelatie. Voor btw-aspecten geldt de Wet op de Omzetbelasting 1968.',
  },
  {
    question: 'Is een ZZP contract verplicht in Nederland?',
    answer: 'Een schriftelijk ZZP contract is niet wettelijk verplicht in Nederland, maar het is sterk aanbevolen. Zonder schriftelijk contract is het moeilijk om afspraken te bewijzen bij een geschil. Bovendien helpt een goed contract bij de beoordeling van de arbeidsrelatie in het kader van de Wet DBA.',
  },
  {
    question: 'Kan ik een gratis ZZP contract template gebruiken voor Nederland?',
    answer: 'Ja, met Pactorae kun je gratis een professioneel ZZP contract genereren dat specifiek is afgestemd op de Nederlandse wetgeving. Onze generator vraagt naar jouw KvK-nummer, btw-nummer en de details van de opdracht, en maakt in 30 seconden een juridisch correct contract op maat voor Nederland.',
  },
];

const FaqItem = ({ faq }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="border border-gray-200 rounded-xl bg-white shadow-sm overflow-hidden">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-6 py-5 text-left focus:outline-none"
        aria-expanded={open}
      >
        <span className="text-base font-semibold text-[#2F4E6F] pr-4">{faq?.question}</span>
        <span
          className="flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center transition-transform duration-200"
          style={{ backgroundColor: '#FF8C00', transform: open ? 'rotate(45deg)' : 'rotate(0deg)' }}
        >
          <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M12 4v16m8-8H4" />
          </svg>
        </span>
      </button>
      {open && (
        <div className="px-6 pb-5">
          <p className="text-gray-600 leading-relaxed">{faq?.answer}</p>
        </div>
      )}
    </div>
  );
};

const NetherlandsFaq = () => (
  <section className="mb-12">
    <h2 className="text-2xl font-bold text-[#2F4E6F] mb-6">Veelgestelde vragen over ZZP contracten in Nederland</h2>
    <div className="space-y-3">
      {faqs?.map((faq, i) => <FaqItem key={i} faq={faq} />)}
    </div>
  </section>
);

export default NetherlandsFaq;
